function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(.733)"
}, React.createElement("path", {
  fill: "#FEE1D9",
  d: "M10.633.5C5.028.5.483 5.201.483 11a10.62 10.62 0 0 0 3.481 7.902c.23 1.223 1.268 2.147 2.517 2.147.284 0 .55-.059.805-.146 1.05.38 2.173.597 3.347.597 5.606 0 10.15-4.701 10.15-10.5S16.24.5 10.633.5z"
})), React.createElement("path", {
  fill: "#FC673F",
  d: "M11.366 1C6.028 1 1.7 5.477 1.7 11c0 2.97 1.25 5.635 3.238 7.469l-.644.746C2.111 17.2.733 14.267.733 11c0-6.075 4.762-11 10.633-11C17.24 0 22 4.925 22 11s-4.76 11-10.633 11c-1.216 0-2.386-.212-3.476-.602l.316-.945c.99.354 2.053.547 3.16.547 5.339 0 9.667-4.477 9.667-10S16.705 1 11.366 1z"
}), React.createElement("g", {
  transform: "translate(3.667 12.138)"
}, React.createElement("path", {
  fill: "#FC673F",
  d: "M3.548 8.411c-1.148 0-2.083-.967-2.083-2.155 0-.677.797-2.458 2.083-4.665 1.288 2.207 2.084 3.988 2.084 4.665 0 1.188-.935 2.155-2.084 2.155zm4.266-5.8c-.818 0-1.568.337-2.165.823A37.557 37.557 0 0 0 4.303.95C3.981.4 3.12.399 2.793.95 1.746 2.733.498 5.1.498 6.256c0 1.74 1.368 3.155 3.05 3.155 1.593 0 2.89-1.274 3.025-2.888l.004-.002c.319-.19.686-.349 1.237-.349.696 0 1.054.239 1.4.469.292.201.62.42 1.075.42.348 0 .656-.139.88-.379a1.27 1.27 0 0 0 .318-.871c0-1.21-1.712-3.2-3.673-3.2z"
})), React.createElement("g", {
  transform: "translate(3.667 6.069)"
}, React.createElement("path", {
  fill: "#FC673F",
  d: "M2.529 1.524C3.373.809 4.442.57 4.49.32c.048-.251-.655-.337-1.167-.158-.51.178-1.25.614-1.84 1.355C1.249 1.81.406 3.32.745 3.475c.18.083 1.032-1.314 1.784-1.951z"
})), React.createElement("g", {
  transform: "translate(13.933 6.069)"
}, React.createElement("path", {
  fill: "#FC673F",
  d: "M2.605 1.524C1.761.809.692.57.645.32.594.069 1.298-.017 1.81.162c.51.178 1.25.614 1.84 1.355.233.294 1.077 1.803.737 1.958-.18.083-1.031-1.314-1.783-1.951z"
})), React.createElement("g", {
  transform: "translate(6.6 8.345)"
}, React.createElement("path", {
  fill: "#FC673F",
  d: "M2.959 2.022c0 1.052-.542 1.905-1.21 1.905-.667 0-1.209-.853-1.209-1.905C.54.971 1.082.118 1.75.118c.667 0 1.209.853 1.209 1.904z"
})), React.createElement("g", {
  transform: "translate(13.2 8.345)"
}, React.createElement("path", {
  fill: "#FC673F",
  d: "M2.449 2.022c0 1.052-.542 1.905-1.209 1.905-.668 0-1.21-.853-1.21-1.905C.03.971.573.118 1.24.118c.667 0 1.209.853 1.209 1.904z"
})));

var SvgSad = function SvgSad(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSad, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Sad.8c69a174.svg";
export { ForwardRef as ReactComponent };